export class WorkspaceRoutes
{
	static Home = "/";
	static WorkspaceList = "/workspace/list";
	static WorkspaceNew = "/workspace/new";
	static WorkspaceCopy(id: string)
	{
		return `/workspace/${id}/new`;
	}
	static WorkspaceEdit(id: string)
	{
		return `/workspace/${id}/edit`;
	}
	static WorkspaceView(id: string)
	{
		return `/workspace/${id}/view`;
	}
}